import { Component, OnInit } from '@angular/core';
import {LayoutService} from "../layout.service";
import { Router } from '@angular/router';
import swal from "sweetalert2";
@Component({
  selector: 'sa-ribbon',
  templateUrl: './ribbon.component.html',
  styleUrls: ['./ribbon.component.css']
})
export class RibbonComponent implements OnInit {
  enseigneName:string;
  search:string;
  connectedUser: any;
  constructor(private layoutService: LayoutService,private router:Router) {}

  ngOnInit() {
    //this.enseigneName = !!JSON.parse(localStorage.getItem('enseigne')) ? JSON.parse(localStorage.getItem('enseigne')).Nom: "Admin";
    this.connectedUser = !!JSON.parse(localStorage.getItem('enseigne')) ? JSON.parse(localStorage.getItem('enseigne')) : '';
  }

  resetWidgets() {
    this.layoutService.factoryReset()
  }
  confirmLogout() {
    swal({
      title: 'Déconnexion',
      text: "Voulez-vous fermer votre session ?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#F16E00',
      cancelButtonColor: '#425660',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Valider'
    }).then((result) => {
      if (result.value) {
        this.logout()
      }
    })
  }

    redirectToAuth = () => {
      return new Promise(resolve => {
        resolve(true);
        this.router.navigateByUrl('/auth')
      });
    }
    resetStorage = () => {
      return new Promise(resolve => {
        resolve(true);
        localStorage.removeItem('enseigne')
      });
    }
  logout = async() => {
    await this.redirectToAuth();
    await this.resetStorage();
  }
}
